import type { SVGProps } from 'react';
const SvgStayCurrentLandscape = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#stay_current_landscape_svg__a)">
      <path
        fill="currentColor"
        d="M1.01 7 1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2ZM19 7v10H5V7h14Z"
      />
    </g>
    <defs>
      <clipPath id="stay_current_landscape_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStayCurrentLandscape;
